import "./ReminderBanner.css";

const ReminderBanner = () => {
  return (
    <section 
      className="reminder-banner"
      aria-label="E-Way Bill Auto Reminder Banner"
    >
      <h2 className="reminder-heading">
        Forgot to extend your E-Way Bill?
      </h2>

      <p className="reminder-text">
        No worries — Saral E-Way will take care of it automatically.
      </p>
    </section>
  );
};

export default ReminderBanner;
